import React, { createContext, useContext, useMemo, FC, ReactNode } from 'react';

// Create a context for the parent ID
const ParentIdContext = createContext<string | null>(null);

// Hook to use the ParentId context
export const useParentId = (): string | null => {
  return useContext(ParentIdContext);
};


// Provider component
interface ParentIdProviderProps {
  id: string;
  children: ReactNode;
}

export const ParentIdProvider: FC<ParentIdProviderProps> = ({ id, children }) => {
  const value = useMemo(() => id, [id]);
  return (
    <ParentIdContext.Provider value={value}>
      {children}
    </ParentIdContext.Provider>
  );
};
